import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { BarChart } from "@mui/x-charts/BarChart";

export default function AppBarChart(props) {
  const theme = useTheme();
  const colorPalette = [
    (theme.vars || theme).palette.primary.dark,
    (theme.vars || theme).palette.primary.main,
    (theme.vars || theme).palette.primary.light,
  ];

  const data = props.data || {};
  const xAxisLabels = data.labels || [];
  const dataToShow = data.data || [];
  let total = 0;
  let yAxisData = dataToShow.map((item, index) => {
    total += item.values.reduce((acc, val) => acc + val, 0);
    return {
      id: index,
      label: item.label,
      data: item.values || [],
      stack: item.stack || "A",
    };
  });

  return (
    <>
      <Stack sx={{ justifyContent: "space-between" }}>
        <Stack
          direction="row"
          sx={{
            alignContent: { xs: "center", sm: "flex-start" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="h4" component="p">
            {total > 1000000
              ? `${(total / 1000000).toFixed(1)}M`
              : total > 1000
                ? `${(total / 1000).toFixed(1)}K`
                : total}
          </Typography>
          <Chip size="small" color="success" label={`${data.changePercent}%`} />
        </Stack>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {props.title || "Bar Chart"}
        </Typography>
      </Stack>

      <BarChart
        borderRadius={8}
        colors={colorPalette}
        xAxis={[
          {
            scaleType: "band",
            categoryGapRatio: 0.5,
            data: xAxisLabels,
          },
        ]}
        series={yAxisData}
        height={250}
        margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
        grid={{ horizontal: true }}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
      />
    </>
  );
}
